import React from 'react';

import '../style.css';
import '../home.css';
import '../home_mobile.css';
import '../styles/home_fontstyles.css';
import createPreview from '../../components/banner/previewBannerTemplate';
import setDefaultImage from '../../../layout/mobile/webBuilder/common/setDefaultImage';
import { makeStyles } from '@material-ui/core/styles';
import social_medias from '../../components/aboutus/previewAboutTemplate';
import ProductCard from '../../components/ProductCard';
import { useHistory, useLocation } from 'react-router-dom';
import ShowMoreText from 'react-show-more-text';
import {
  Link,
  IconButton,
  Badge,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import {
  AccountCircleOutlined,
  ShoppingCartOutlined,
} from '@material-ui/icons';
import StoreActions from '../../components/StoreActions';
import Path from '../../../../../Paths';
import Footer from '../../components/footer/footer';
const Homepage = (props) => {
  const { storeInfo } = props;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const color = storeInfo && storeInfo.color;
  let cart = useSelector((state) => state.store.items);
  let token = sessionStorage.getItem('TOKEN');
  let user = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
  const product_categories = useSelector(
    (state) => state.store.product_categories?.categories
  );
  const useStyles = makeStyles((theme) => ({
    header: {
      color: color && color.primary.contrastText,
      fontFamily: storeInfo && storeInfo.font.family,
    },
    slogan: {
      color: color && color.primary.contrastText,
    },
    cover_img_btn: {
      backgroundColor: color && color.secondary.main,
      color: color && color.secondary.contrastText,
    },
    customBadge: {
      backgroundColor: '#C0492C',
      color: '#fff',
    },
  }));

  function cartButton() {
    if (location.pathname.includes('cart') || props.productList.length === 0) {
      return () => {
        history.push(`/shop/${storeInfo.site}/cart`);
      };
    } else {
      return () => dispatch(StoreActions.showCartDrawer(true));
    }
  }

  function handleGoToDashboard() {
    if (user.is_seller && user.is_buyer) {
      history.push(Path.DASHBOARD);
    } else {
      history.push(Path.BUYER_DASHBOARD);
    }
  }

  const classes = useStyles();
  return (
    <>
      {isMobile ? (
        <div className="m-leftist-home-page38234-container">
          <div className="m-leftist-home-page38234-m-leftist-home-page38234">
            <div className="m-leftist-home-page38234-group36338236">
              <div className="m-leftist-home-page38234-group21038238">
                <span className="m-leftist-home-page38234-text02">
                  Powered by
                </span>
                <img
                  src="data:image/svg+xml;base64,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"
                  alt="SentroI38238413126"
                  className="m-leftist-home-page38234-image03"
                />
              </div>
            </div>
            <img
              src={
                storeInfo && storeInfo.cover_image
                  ? typeof storeInfo.cover_image === 'object'
                    ? createPreview(storeInfo.cover_image)
                    : storeInfo.cover_image
                  : setDefaultImage(storeInfo.template, 'cover_image')
              }
              alt="image1738239"
              className="m-leftist-home-page38234-image04"
            />
            <div className="m-leftist-home-page38234-group36038240">
              <span
                className={`${classes.header} m-leftist-home-page38234-text03 lightH2`}
              >
                {storeInfo && storeInfo.name}
              </span>
              <span
                className={`${classes.slogan} m-leftist-home-page38234-text04 lightBody`}
              >
                {storeInfo && storeInfo.slogan}
              </span>
            </div>
            <button
              className={`m-leftist-home-page38234-button38243 `}
              onClick={() =>
                history.push(
                  `/shop/${
                    storeInfo && storeInfo.site
                  }/products/?category=All&sortBy=-created_on`
                )
              }
            >
              <button
                className={`m-leftist-home-page38234-buttongrid-i3824310262260 ${classes.cover_img_btn}`}
              >
                <span className="m-leftist-home-page38234-text05 lightH5">
                  Shop now
                </span>
              </button>
            </button>
            <div className="m-leftist-home-page38234-group62538244">
              {props.productList && props.productList.length >= 0
                ? props.productList
                    .filter((item) => item.status === 'active' && item.featured)
                    .slice(0, 3)
                    .map((item, label) => {
                      return (
                        <div
                          style={{ width: isMobile ? '100%' : '30%' }}
                          className="px-0"
                        >
                          <ProductCard
                            key={label}
                            onSelect={(value) => props.onSelect(value)}
                            item={item}
                            store={storeInfo}
                          />
                        </div>
                      );
                    })
                : ''}
            </div>

            <span className="m-leftist-home-page38234-text09 lightH3">
              Featured Products
            </span>

            <div
              className="m-leftist-home-page38234-group61938267"
              onClick={() =>
                history.push(
                  `/shop/${
                    storeInfo && storeInfo.site
                  }/products/?category=All&sortBy=-created_on`
                )
              }
            >
              <span className="m-leftist-home-page38234-text15 lightH4">
                View all products
              </span>
              <img
                alt="Vector38269"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMzAnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAzMCAxNicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTI5Ljk1NjcgNy43ODI1NUMyOS45MjkyIDcuNzEyNDYgMjkuODg4IDcuNjQ4NDMgMjkuODM1NSA3LjU5NDEzTDIyLjMzNDMgMC4xNjc5MTRDMjIuMjgwNSAwLjExNDY3OSAyMi4yMTY2IDAuMDcyNDUwMyAyMi4xNDYzIDAuMDQzNjM5NkMyMi4wNzYgMC4wMTQ4Mjg5IDIyLjAwMDYgMCAyMS45MjQ1IDBDMjEuNzcwOCAwIDIxLjYyMzQgMC4wNjA0MDA1IDIxLjUxNDcgMC4xNjc5MTRDMjEuNDYwOSAwLjIyMTE0OSAyMS40MTgyIDAuMjg0MzQ5IDIxLjM4OTEgMC4zNTM5MDRDMjEuMzYgMC40MjM0NTkgMjEuMzQ1IDAuNDk4MDA4IDIxLjM0NSAwLjU3MzI5NEMyMS4zNDUgMC43MjUzNDEgMjEuNDA2IDAuODcxMTYxIDIxLjUxNDcgMC45Nzg2NzVMMjguMDM0OCA3LjQyODU2SDAuNTc3MTYzQzAuNDI0MDkgNy40Mjg1NiAwLjI3NzI4NiA3LjQ4ODcxIDAuMTY5MDQ3IDcuNTk1NzlDMC4wNjA4MDgxIDcuNzAyODYgMCA3Ljg0ODA5IDAgNy45OTk1MUMwIDguMTUwOTQgMC4wNjA4MDgxIDguMjk2MTcgMC4xNjkwNDcgOC40MDMyNEMwLjI3NzI4NiA4LjUxMDMyIDAuNDI0MDkgOC41NzA0NyAwLjU3NzE2MyA4LjU3MDQ3SDI4LjAzNDhMMjEuNTE0NyAxNS4wMjA0QzIxLjQ2MDYgMTUuMDczNCAyMS40MTc3IDE1LjEzNjYgMjEuMzg4NCAxNS4yMDYyQzIxLjM1OTEgMTUuMjc1NyAyMS4zNDQgMTUuMzUwNCAyMS4zNDQgMTUuNDI1N0MyMS4zNDQgMTUuNTAxMSAyMS4zNTkxIDE1LjU3NTcgMjEuMzg4NCAxNS42NDUzQzIxLjQxNzcgMTUuNzE0OSAyMS40NjA2IDE1Ljc3OCAyMS41MTQ3IDE1LjgzMTFDMjEuNTY4NCAxNS44ODQ2IDIxLjYzMjIgMTUuOTI3MSAyMS43MDI2IDE1Ljk1NjFDMjEuNzcyOSAxNS45ODUxIDIxLjg0ODMgMTYgMjEuOTI0NSAxNkMyMi4wMDA3IDE2IDIyLjA3NjEgMTUuOTg1MSAyMi4xNDY1IDE1Ljk1NjFDMjIuMjE2OCAxNS45MjcxIDIyLjI4MDYgMTUuODg0NiAyMi4zMzQzIDE1LjgzMTFMMjkuODM1NSA4LjQwNDg5QzI5Ljg4OCA4LjM1MDU5IDI5LjkyOTIgOC4yODY1NiAyOS45NTY3IDguMjE2NDhDMzAuMDE0NCA4LjA3NzQ3IDMwLjAxNDQgNy45MjE1NiAyOS45NTY3IDcuNzgyNTVaJyBmaWxsPScjM0E0OTM1Jy8+Cjwvc3ZnPgo="
                className="m-leftist-home-page38234-svg"
              />
            </div>
            <div
              // style={{ backgroundColor: color && color.primary.main }}
              className="m-leftist-home-page38234-image23"
            />
            <div className="m-leftist-home-page38234-group63238271">
              <div className="m-leftist-home-page38234-group438272">
                <div className="m-leftist-home-page38234-frame61838273">
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAxNiAxNicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTE1LjMzMzIgOC4wNDQ3MUMxNS4zMzMyIDMuOTY4OTggMTIuMDUwOSAwLjY2Njc0OCA3Ljk5OTg0IDAuNjY2NzQ4QzMuOTQ4NzYgMC42NjY3NDggMC42NjY1MDQgMy45Njg5OCAwLjY2NjUwNCA4LjA0NDcxQzAuNjY2NTA0IDExLjcyNzEgMy4zNDgyIDE0Ljc3OTUgNi44NTQgMTUuMzMzNFYxMC4xNzc1SDQuOTkxMVY4LjA0NDcxSDYuODU0VjYuNDE5MThDNi44NTQgNC41NzAyMiA3Ljk0ODA5IDMuNTQ4OTEgOS42MjM4MiAzLjU0ODkxQzEwLjQyNjMgMy41NDg5MSAxMS4yNjU1IDMuNjkyOSAxMS4yNjU1IDMuNjkyOVY1LjUwNzY0SDEwLjM0MDZDOS40Mjk4NCA1LjUwNzY0IDkuMTQ1NjcgNi4wNzY0NiA5LjE0NTY3IDYuNjU5ODVWOC4wNDQ3MUgxMS4xNzk1TDEwLjg1NDIgMTAuMTc3NUg5LjE0NTY3VjE1LjMzMzRDMTIuNjUxNSAxNC43Nzk1IDE1LjMzMzIgMTEuNzI3MSAxNS4zMzMyIDguMDQ0NzFaJyBmaWxsPScjM0U0MTQ5Jy8+Cjwvc3ZnPgo="
                    alt="IconFB38274"
                    className="m-leftist-home-page38234-image24"
                  />
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAxNiAxNicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTguMDAwMDcgNC43OTUyNEM2LjIyNjY0IDQuNzk1MjQgNC43OTUzOSA2LjIyNjQ5IDQuNzk1MzkgNy45OTk5M0M0Ljc5NTM5IDkuNzczMzcgNi4yMjY2NCAxMS4yMDQ2IDguMDAwMDcgMTEuMjA0NkM5Ljc3MzUxIDExLjIwNDYgMTEuMjA0OCA5Ljc3MzM3IDExLjIwNDggNy45OTk5M0MxMS4yMDQ4IDYuMjI2NDkgOS43NzM1MSA0Ljc5NTI0IDguMDAwMDcgNC43OTUyNFpNOC4wMDAwNyAxMC4wODI3QzYuODUzMiAxMC4wODI3IDUuOTE3MjYgOS4xNDY4IDUuOTE3MjYgNy45OTk5M0M1LjkxNzI2IDYuODUzMDUgNi44NTMyIDUuOTE3MTIgOC4wMDAwNyA1LjkxNzEyQzkuMTQ2OTUgNS45MTcxMiAxMC4wODI5IDYuODUzMDUgMTAuMDgyOSA3Ljk5OTkzQzEwLjA4MjkgOS4xNDY4IDkuMTQ2OTUgMTAuMDgyNyA4LjAwMDA3IDEwLjA4MjdaTTExLjMzNiAzLjkxNzExQzEwLjkyMTkgMy45MTcxMSAxMC41ODc2IDQuMjUxNDkgMTAuNTg3NiA0LjY2NTU1QzEwLjU4NzYgNS4wNzk2MiAxMC45MjE5IDUuNDEzOTkgMTEuMzM2IDUuNDEzOTlDMTEuNzUwMSA1LjQxMzk5IDEyLjA4NDQgNS4wODExOCAxMi4wODQ0IDQuNjY1NTVDMTIuMDg0NiA0LjU2NzIzIDEyLjA2NTMgNC40Njk4NSAxMi4wMjc3IDQuMzc4OTlDMTEuOTkwMiA0LjI4ODEzIDExLjkzNSA0LjIwNTU4IDExLjg2NTUgNC4xMzYwNUMxMS43OTYgNC4wNjY1MyAxMS43MTM0IDQuMDExNCAxMS42MjI2IDMuOTczODRDMTEuNTMxNyAzLjkzNjI3IDExLjQzNDMgMy45MTY5OSAxMS4zMzYgMy45MTcxMVYzLjkxNzExWk0xNC4yNDY5IDcuOTk5OTNDMTQuMjQ2OSA3LjEzNzQzIDE0LjI1NDggNi4yODI3NCAxNC4yMDYzIDUuNDIxOEMxNC4xNTc5IDQuNDIxOCAxMy45Mjk4IDMuNTM0MyAxMy4xOTg1IDIuODAzMDVDMTIuNDY1NyAyLjA3MDI0IDExLjU3OTggMS44NDM2OCAxMC41Nzk4IDEuNzk1MjRDOS43MTcyNiAxLjc0NjggOC44NjI1NyAxLjc1NDYyIDguMDAxNjQgMS43NTQ2MkM3LjEzOTE0IDEuNzU0NjIgNi4yODQ0NSAxLjc0NjggNS40MjM1MSAxLjc5NTI0QzQuNDIzNTEgMS44NDM2OCAzLjUzNjAxIDIuMDcxOCAyLjgwNDc2IDIuODAzMDVDMi4wNzE5NSAzLjUzNTg3IDEuODQ1MzkgNC40MjE4IDEuNzk2OTUgNS40MjE4QzEuNzQ4NTEgNi4yODQzIDEuNzU2MzIgNy4xMzg5OSAxLjc1NjMyIDcuOTk5OTNDMS43NTYzMiA4Ljg2MDg2IDEuNzQ4NTEgOS43MTcxMiAxLjc5Njk1IDEwLjU3ODFDMS44NDUzOSAxMS41NzgxIDIuMDczNTEgMTIuNDY1NiAyLjgwNDc2IDEzLjE5NjhDMy41Mzc1NyAxMy45Mjk2IDQuNDIzNTEgMTQuMTU2MiA1LjQyMzUxIDE0LjIwNDZDNi4yODYwMSAxNC4yNTMxIDcuMTQwNyAxNC4yNDUyIDguMDAxNjQgMTQuMjQ1MkM4Ljg2NDE0IDE0LjI0NTIgOS43MTg4MiAxNC4yNTMxIDEwLjU3OTggMTQuMjA0NkMxMS41Nzk4IDE0LjE1NjIgMTIuNDY3MyAxMy45MjgxIDEzLjE5ODUgMTMuMTk2OEMxMy45MzEzIDEyLjQ2NCAxNC4xNTc5IDExLjU3ODEgMTQuMjA2MyAxMC41NzgxQzE0LjI1NjMgOS43MTcxMiAxNC4yNDY5IDguODYyNDMgMTQuMjQ2OSA3Ljk5OTkzVjcuOTk5OTNaTTEyLjg3MTkgMTEuNjg0M0MxMi43NTc5IDExLjk2ODcgMTIuNjIwNCAxMi4xODEyIDEyLjQwMDEgMTIuMzk5OUMxMi4xNzk4IDEyLjYyMDIgMTEuOTY4OCAxMi43NTc3IDExLjY4NDQgMTIuODcxOEMxMC44NjI2IDEzLjE5ODQgOC45MTEwMSAxMy4xMjQ5IDguMDAwMDcgMTMuMTI0OUM3LjA4OTE0IDEzLjEyNDkgNS4xMzYwMSAxMy4xOTg0IDQuMzE0MTQgMTIuODczNEM0LjAyOTc2IDEyLjc1OTMgMy44MTcyNiAxMi42MjE4IDMuNTk4NTEgMTIuNDAxNUMzLjM3ODIgMTIuMTgxMiAzLjI0MDcgMTEuOTcwMiAzLjEyNjY0IDExLjY4NTlDMi44MDE2NCAxMC44NjI0IDIuODc1MDcgOC45MTA4NyAyLjg3NTA3IDcuOTk5OTNDMi44NzUwNyA3LjA4ODk5IDIuODAxNjQgNS4xMzU4NyAzLjEyNjY0IDQuMzEzOTlDMy4yNDA3IDQuMDI5NjIgMy4zNzgyIDMuODE3MTIgMy41OTg1MSAzLjU5ODM3QzMuODE4ODIgMy4zNzk2MiA0LjAyOTc2IDMuMjQwNTUgNC4zMTQxNCAzLjEyNjQ5QzUuMTM2MDEgMi44MDE0OSA3LjA4OTE0IDIuODc0OTMgOC4wMDAwNyAyLjg3NDkzQzguOTExMDEgMi44NzQ5MyAxMC44NjQxIDIuODAxNDkgMTEuNjg2IDMuMTI2NDlDMTEuOTcwNCAzLjI0MDU1IDEyLjE4MjkgMy4zNzgwNSAxMi40MDE2IDMuNTk4MzdDMTIuNjIxOSAzLjgxODY4IDEyLjc1OTQgNC4wMjk2MiAxMi44NzM1IDQuMzEzOTlDMTMuMTk4NSA1LjEzNTg3IDEzLjEyNTEgNy4wODg5OSAxMy4xMjUxIDcuOTk5OTNDMTMuMTI1MSA4LjkxMDg3IDEzLjE5ODUgMTAuODYyNCAxMi44NzE5IDExLjY4NDNaJyBmaWxsPScjMkIyRDMyJy8+Cjwvc3ZnPgo="
                    alt="iconoutlinedbrandandlogosinstagram38275"
                    className="m-leftist-home-page38234-image25"
                  />
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAxNiAxNicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTE0LjUwMDEgMy45NzM0NEMxNC4wMjIgNC4xNzk2OSAxMy41MDE3IDQuMzI4MTMgMTIuOTY1NyA0LjM4NTk0QzEzLjUyMjEgNC4wNTUzNyAxMy45Mzg4IDMuNTMzMTMgMTQuMTM3NiAyLjkxNzE5QzEzLjYxNTUgMy4yMjc4IDEzLjA0MzUgMy40NDU2MSAxMi40NDcgMy41NjA5NEMxMi4xOTc3IDMuMjk0NDIgMTEuODk2MSAzLjA4MjEgMTEuNTYxMiAyLjkzNzIxQzExLjIyNjIgMi43OTIzMSAxMC44NjUgMi43MTc5NSAxMC41MDAxIDIuNzE4NzZDOS4wMjM1MyAyLjcxODc2IDcuODM2MDQgMy45MTU2MyA3LjgzNjA0IDUuMzg0MzhDNy44MzYwNCA1LjU5MDYzIDcuODYxMDQgNS43OTY4OCA3LjkwMTY2IDUuOTk1MzJDNS42OTA3MiA1Ljg3OTY5IDMuNzE4ODUgNC44MjM0NCAyLjQwNzkxIDMuMjA2MjZDMi4xNjkwNCAzLjYxNDI1IDIuMDQzODcgNC4wNzg4IDIuMDQ1NDEgNC41NTE1N0MyLjA0NTQxIDUuNDc2NTcgMi41MTU3MiA2LjI5MjE5IDMuMjMyOTEgNi43NzE4OEMyLjgxMDI2IDYuNzU1MjQgMi4zOTc1MSA2LjYzOTA3IDIuMDI4MjIgNi40MzI4MlY2LjQ2NTYzQzIuMDI4MjIgNy43NjA5NCAyLjk0Mzg1IDguODM0MzggNC4xNjQxNiA5LjA4MTI2QzMuOTM1MDMgOS4xNDA3NyAzLjY5OTMzIDkuMTcxMjIgMy40NjI2IDkuMTcxODhDMy4yODkxNiA5LjE3MTg4IDMuMTI1MSA5LjE1NDY5IDIuOTU5NDcgOS4xMzEyNkMzLjI5Njk3IDEwLjE4NzUgNC4yNzk3OSAxMC45NTQ3IDUuNDUwMSAxMC45Nzk3QzQuNTM0NDcgMTEuNjk2OSAzLjM4NzYgMTIuMTE4OCAyLjE0MjI5IDEyLjExODhDMS45MTg4NSAxMi4xMTg4IDEuNzEyNiAxMi4xMTA5IDEuNDk4NTQgMTIuMDg1OUMyLjY3OTc5IDEyLjg0MzggNC4wODEzNSAxMy4yODEzIDUuNTkwNzIgMTMuMjgxM0MxMC40OTA3IDEzLjI4MTMgMTMuMTcyIDkuMjIxODggMTMuMTcyIDUuNjk4NDRDMTMuMTcyIDUuNTgyODIgMTMuMTcyIDUuNDY3MTkgMTMuMTY0MiA1LjM1MTU3QzEzLjY4MjkgNC45NzE4OCAxNC4xMzc2IDQuNTAxNTcgMTQuNTAwMSAzLjk3MzQ0WicgZmlsbD0nIzJCMkQzMicvPgo8L3N2Zz4K"
                    alt="iconoutlinedbrandandlogostwitter38276"
                    className="m-leftist-home-page38234-image26"
                  />
                </div>
              </div>
              <span
                className="m-leftist-home-page38234-text16 lightH2"
                // style={{ color: color && color.primary.contrastText }}
              >
                About Us
              </span>
              <span
                className="m-leftist-home-page38234-text17 lightH4"
                // style={{ color: color && color.primary.contrastText }}
              >
                <ShowMoreText
                  lines={6}
                  more="See more"
                  onClick={() =>
                    history.push(`/shop/${storeInfo.site}/about_us`)
                  }
                  expanded={false}
                >
                  {storeInfo && storeInfo.description}
                </ShowMoreText>
              </span>
            </div>
            <img
              src={
                storeInfo && storeInfo.aboutus_image
                  ? typeof storeInfo.aboutus_image === 'object'
                    ? createPreview(storeInfo.aboutus_image)
                    : storeInfo.aboutus_image
                  : setDefaultImage(storeInfo.template, 'aboutus_image')
              }
              alt="image1838279"
              className="m-leftist-home-page38234-image27"
            />
          </div>
        </div>
      ) : (
        <div className="frame2241591187-frame2241591187">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNTA5JyBoZWlnaHQ9JzUzMicgdmlld0JveD0nMCAwIDUwOSA1MzInIGZpbGw9J25vbmUnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+CjxyZWN0IHdpZHRoPSc1MDknIGhlaWdodD0nNTMyJyBmaWxsPScjRkFGQUZBJy8+Cjwvc3ZnPgo="
            alt="Rectangle230591188"
            className="frame2241591187-image"
          />
          <div className="frame2241591187-group4591189">
            {social_medias('rgba(62, 65, 73, 1)', storeInfo)}
          </div>
          <img
            src={
              storeInfo && storeInfo.cover_image
                ? typeof storeInfo.cover_image === 'object'
                  ? createPreview(storeInfo.cover_image)
                  : storeInfo.cover_image
                : setDefaultImage(storeInfo.template, 'cover_image')
            }
            alt="image17591194"
            className="frame2241591187-image04"
          />
          <span className="frame2241591187-text lightH3">
            Featured Products
          </span>
          <div
            className="frame2241591187-group619591196"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              history.push(
                `/shop/${
                  storeInfo && storeInfo.site
                }/products/?category=All&sortBy=-created_on`
              )
            }
          >
            <span className="frame2241591187-text01 lightH3">
              View all products
            </span>
            <img
              alt="Vector591198"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAyNiAxNicgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KPHBhdGggZD0nTTI1LjQwNzcgNy4zNTIwMUMyNS4zODQ0IDcuMjg1OCAyNS4zNDk1IDcuMjI1MzEgMjUuMzA0OSA3LjE3NDAyTDE4Ljk0MjggMC4xNTg2MjVDMTguODk3MiAwLjEwODMzNSAxOC44NDMgMC4wNjg0NDIzIDE4Ljc4MzMgMC4wNDEyMjU0QzE4LjcyMzcgMC4wMTQwMDg1IDE4LjY1OTggMCAxOC41OTUyIDBDMTguNDY0OSAwIDE4LjMzOTkgMC4wNTcwNTkgMTguMjQ3NyAwLjE1ODYyNUMxOC4yMDIgMC4yMDg5MTUgMTguMTY1OCAwLjI2ODYxOCAxOC4xNDExIDAuMzM0MzI2QzE4LjExNjQgMC40MDAwMzMgMTguMTAzNyAwLjQ3MDQ1OCAxOC4xMDM3IDAuNTQxNTc5QzE4LjEwMzcgMC42ODUyMTQgMTguMTU1NSAwLjgyMjk2NyAxOC4yNDc3IDAuOTI0NTMzTDIzLjc3NzYgNy4wMTc2SDAuNDg5NTJDMC4zNTk2OTEgNy4wMTc2IDAuMjM1MTggNy4wNzQ0MiAwLjE0MzM3NyA3LjE3NTU4QzAuMDUxNTc0MiA3LjI3NjczIDAgNy40MTM5MiAwIDcuNTU2OTdDMCA3LjcwMDAyIDAuMDUxNTc0MiA3LjgzNzIxIDAuMTQzMzc3IDcuOTM4MzZDMC4yMzUxOCA4LjAzOTUxIDAuMzU5NjkxIDguMDk2MzQgMC40ODk1MiA4LjA5NjM0SDIzLjc3NzZMMTguMjQ3NyAxNC4xODk0QzE4LjIwMTggMTQuMjM5NSAxOC4xNjU0IDE0LjI5OTIgMTguMTQwNSAxNC4zNjQ5QzE4LjExNTcgMTQuNDMwNyAxOC4xMDI5IDE0LjUwMTIgMTguMTAyOSAxNC41NzI0QzE4LjEwMjkgMTQuNjQzNiAxOC4xMTU3IDE0LjcxNDEgMTguMTQwNSAxNC43Nzk4QzE4LjE2NTQgMTQuODQ1NSAxOC4yMDE4IDE0LjkwNTIgMTguMjQ3NyAxNC45NTUzQzE4LjI5MzIgMTUuMDA1OSAxOC4zNDczIDE1LjA0NiAxOC40MDcgMTUuMDczNEMxOC40NjY2IDE1LjEwMDggMTguNTMwNiAxNS4xMTQ5IDE4LjU5NTIgMTUuMTE0OUMxOC42NTk5IDE1LjExNDkgMTguNzIzOCAxNS4xMDA4IDE4Ljc4MzUgMTUuMDczNEMxOC44NDMxIDE1LjA0NiAxOC44OTczIDE1LjAwNTkgMTguOTQyOCAxNC45NTUzTDI1LjMwNDkgNy45Mzk5MkMyNS4zNDk1IDcuODg4NjMgMjUuMzg0NCA3LjgyODE0IDI1LjQwNzcgNy43NjE5M0MyNS40NTY3IDcuNjMwNjEgMjUuNDU2NyA3LjQ4MzMyIDI1LjQwNzcgNy4zNTIwMVonIGZpbGw9JyMzQTQ5MzUnLz4KPC9zdmc+Cg=="
              className="frame2241591187-svg"
            />
          </div>
          <div className="frame2241591187-group625591199">
            {props.productList && props.productList.length >= 0
              ? props.productList
                  .filter((item) => item.status === 'active' && item.featured)
                  .slice(0, 3)
                  .map((item, label) => {
                    return (
                      <div className="px-0 col-4">
                        <ProductCard
                          key={label}
                          onSelect={(value) => props.onSelect(value)}
                          item={item}
                          store={storeInfo}
                        />
                      </div>
                    );
                  })
              : ''}
          </div>

          <button
            className="frame2241591187-button591221"
            onClick={() =>
              history.push(
                `/shop/${
                  storeInfo && storeInfo.site
                }/products/?category=All&sortBy=-created_on`
              )
            }
          >
            <button
              className={`frame2241591187-buttongrid-i59122110262260 ${classes.cover_img_btn}`}
            >
              <span className="frame2241591187-text10 lightH5">Shop now</span>
            </button>
          </button>
          <div className="frame2241591187-group6591222">
            <span
              className={`frame2241591187-text11 lightH1 ${classes.header}`}
            >
              {storeInfo && storeInfo.name}
            </span>
            <span
              className={`frame2241591187-text12 lightBody ${classes.slogan}`}
            >
              {storeInfo && storeInfo.slogan}
            </span>
          </div>

          <img
            src={
              storeInfo && storeInfo.aboutus_image
                ? typeof storeInfo.aboutus_image === 'object'
                  ? createPreview(storeInfo.aboutus_image)
                  : storeInfo.aboutus_image
                : setDefaultImage(storeInfo.template, 'aboutus_image')
            }
            alt="image18591226"
            className="frame2241591187-image23"
          />
          <span className="frame2241591187-text14 lightH2">About Us</span>
          <span className="frame2241591187-text15 description">
            <ShowMoreText
              lines={6}
              more="See more"
              onClick={() => history.push(`/shop/${storeInfo.site}/about_us`)}
              expanded={false}
            >
              {storeInfo && storeInfo.description}
            </ShowMoreText>
          </span>
          <div className="frame2241591187-footer591229">
            <img
              src
              alt="Rectangle9I59122952025"
              className="frame2241591187-image24"
            />
            <span className="frame2241591187-text16 regularSmall">
              Copyright © 2021 Shop Name
            </span>
            <div className="frame2241591187-group361i591229413474">
              <span className="frame2241591187-text17 regularXsmall">
                Powered by
              </span>
              <img
                src
                alt="SentroI591229413476"
                className="frame2241591187-image25"
              />
            </div>
            <div className="frame2241591187-frame2236i59122910228387">
              <span className="frame2241591187-text18 regularXsmall">
                Privacy Policy
              </span>
              <span className="frame2241591187-text19 regularXsmall">
                Terms and Conditions
              </span>
            </div>
          </div>
          <div
            className="position-absolute"
            style={{ bottom: 0, left: 0, right: 0 }}
          >
            <Footer store={storeInfo} />
          </div>
        </div>
      )}
    </>
  );
};

export default Homepage;
